import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { easeOut, mediumDurationMs, smallDurationMs } from '@atlaskit/motion';
import { B100, B200, N0, N200, N30A } from '@atlaskit/theme/colors';
import { GRAB_AREA_LINE_SELECTOR, GRAB_AREA_SELECTOR, IS_SIDEBAR_DRAGGING, RESIZE_BUTTON_SELECTOR } from '../../common/constants';
export var resizeControlCSS = function resizeControlCSS(setIsGrabAreaFocused, isLeftSidebarCollapsed) {
  var _$concat, _ref;

  return _ref = {
    left: '100%',
    top: 0,
    bottom: 0,
    position: 'absolute',
    outline: 'none'
  }, _defineProperty(_ref, "[".concat(GRAB_AREA_SELECTOR, "]:enabled"), (_$concat = {}, _defineProperty(_$concat, "&:hover [".concat(GRAB_AREA_LINE_SELECTOR, "]"), {
    backgroundColor: B100
  }), _defineProperty(_$concat, "&:active [".concat(GRAB_AREA_LINE_SELECTOR, "] , &:focus [").concat(GRAB_AREA_LINE_SELECTOR, "]"), {
    backgroundColor: B200
  }), _defineProperty(_$concat, "&:hover [".concat(RESIZE_BUTTON_SELECTOR, "]:not(:focus):not(:hover)"), {
    color: B100
  }), _defineProperty(_$concat, "&:hover [".concat(RESIZE_BUTTON_SELECTOR, "]"), {
    opacity: 1
  }), _$concat)), _defineProperty(_ref, "[".concat(RESIZE_BUTTON_SELECTOR, "]"), {
    opacity: setIsGrabAreaFocused || isLeftSidebarCollapsed ? 1 : 0
  }), _ref;
};
export var resizeIconButtonCSS = function resizeIconButtonCSS(isCollapsed) {
  return _objectSpread(_objectSpread({
    backgroundColor: N0,
    position: 'absolute',
    top: 32,
    left: 0,
    transform: 'translateX(-50%)',
    border: 0,
    borderRadius: '50%',
    boxShadow: "0 0 0 1px ".concat(N30A, ", 0 2px 4px 1px ").concat(N30A),
    color: N200,
    cursor: 'pointer',
    height: 24,
    opacity: 0,
    outline: 0,
    padding: 0,
    transition: "\n    background-color ".concat(smallDurationMs, "ms linear,\n    color ").concat(smallDurationMs, "ms linear,\n    opacity ").concat(mediumDurationMs, "ms ").concat(easeOut, "\n  "),
    width: 24,
    ':hover': {
      backgroundColor: B100,
      color: N0,
      opacity: 1
    },
    ':active': {
      backgroundColor: B200,
      color: N0,
      opacity: 1
    },
    ':focus': {
      backgroundColor: B200,
      color: N0,
      opacity: 1
    }
  }, !isCollapsed && {
    transform: 'rotate(180deg)',
    transformOrigin: 7,
    opacity: 1
  }), {}, _defineProperty({}, "[".concat(IS_SIDEBAR_DRAGGING, "] &"), {
    opacity: 1
  }));
};
export var grabAreaCSS = function grabAreaCSS(isLeftSidebarCollapsed) {
  var _objectSpread3;

  return _objectSpread((_objectSpread3 = {
    cursor: 'ew-resize',
    height: '100%',
    width: '24px',
    padding: 0,
    border: 0,
    backgroundColor: 'transparent'
  }, _defineProperty(_objectSpread3, '&::-moz-focus-inner', {
    border: 0
  }), _defineProperty(_objectSpread3, ':focus', {
    outline: 0
  }), _objectSpread3), isLeftSidebarCollapsed && {
    padding: 0,
    border: 0,
    backgroundColor: 'transparent',
    cursor: 'default'
  });
};
export var lineCSS = function lineCSS(isLeftSidebarCollapsed) {
  return _objectSpread({
    display: 'block',
    height: '100%',
    transition: 'background-color 200ms',
    width: 2
  }, isLeftSidebarCollapsed && {
    '&&': {
      backgroundColor: 'transparent'
    }
  });
};
export var increaseHitArea = {
  position: 'absolute',
  left: -8,
  right: -12,
  bottom: -8,
  top: -8
};
var colorStops = "\n    rgba(0, 0, 0, 0.2) 0px,\n    rgba(0, 0, 0, 0.2) 1px,\n    rgba(0, 0, 0, 0.1) 1px,\n    rgba(0, 0, 0, 0) 100%\n  ";
var direction = 'to left';
var transitionDuration = '0.22s';
export var shadowCSS = _defineProperty({
  background: "linear-gradient(".concat(direction, ", ").concat(colorStops, ")"),
  bottom: 0,
  top: 0,
  left: -1,
  opacity: 0.5,
  pointerEvents: 'none',
  position: 'absolute',
  transitionDuration: transitionDuration,
  transitionProperty: 'left, opacity, width',
  transitionTimingFunction: easeOut,
  width: 3
}, "[".concat(IS_SIDEBAR_DRAGGING, "] &"), {
  opacity: 0.8,
  width: 6,
  left: -6
});